"use strict";
var gpsPointSchema = require('./gpsPointSchema'); // For Media that occur along an Activity track, the item must specify the activity and either a time or distance.
// A position cannot be used alone because these items support "focus", which cannot just use proximity, it needs to be
// triggered on a 1D axis (time or distance) to support things like laps and hairpin turns.
var targetSchema = {
    type: 'object',
    required: ['activityId', 'time'],
    additionalProperties: false,
    properties: {
        activityId: {
            type: 'string'
        },
        accountId: {
            type: 'string'
        },
        time: {
            type: 'string',
            format: 'date-time'
        }
    }
}; // A photo that was taken along an activity track. 
// In the future, the camera should be oriented so that the photo aligns with the scene.
var photoSchema = {
    type: 'object',
    required: ['mediaType', 'source', 'target'],
    additionalProperties: false,
    properties: {
        mediaId: {
            type: 'string'
        },
        mediaType: {
            type: 'string',
            enum: ['photo']
        },
        source: {
            type: 'string',
            format: 'uri'
        },
        target: targetSchema
    }
}; // Text that the avatar will "say" along a track. If the text is long, it may be truncated unless the user expands the
// captuion. If focus is true, the scene will pause for a few seconds and the caption will automatically be expanded
// When focus is false, the scene won't pause and only the truncated text will be shown, unless it's expanded
var captionSchema = {
    type: 'object',
    required: ['mediaType', 'text', 'target'],
    additionalProperties: false,
    properties: {
        mediaId: {
            type: 'string'
        },
        mediaType: {
            type: 'string',
            enum: ['caption']
        },
        text: {
            type: 'string'
        },
        target: targetSchema,
        focus: {
            type: 'boolean'
        }
    }
}; // A label for a specific geographic location, similar to how G00gle Earth labels it's places.
var labelSchema = {
    type: 'object',
    required: ['mediaType', 'title', 'location'],
    additionalProperties: false,
    properties: {
        mediaId: {
            type: 'string'
        },
        mediaType: {
            type: 'string',
            enum: ['label']
        },
        title: {
            type: 'string'
        },
        location: gpsPointSchema()
    }
}; // A billboard image that can be placed anywhere and scaled in either world space.
var logoSchema = {
    type: 'object',
    required: ['mediaType', 'source', 'location'],
    additionalProperties: false,
    properties: {
        mediaId: {
            type: 'string'
        },
        mediaType: {
            type: 'string',
            enum: ['logo']
        },
        location: gpsPointSchema(),
        source: {
            type: 'string',
            format: 'uri'
        },
        heightInMeters: {
            type: 'number',
            minimum: 1
        }
    }
}; // @Deprecated: The old Image schema
var deprecatedImageSchema = {
    type: 'object',
    required: ['mediaType', 'content', 'points'],
    additionalProperties: false,
    properties: {
        mediaId: {
            type: 'string'
        },
        mediaType: {
            enum: ['image'],
            type: 'string'
        },
        content: {
            type: 'string',
            format: 'uri'
        },
        height: {
            type: 'number',
            minimum: 1
        },
        width: {
            type: 'number',
            minimum: 1
        },
        points: {
            type: 'array',
            minItems: 1,
            items: gpsPointSchema('height')
        },
        focus: {
            type: 'boolean'
        },
        visibleRadius: {
            type: 'number',
            min: 1
        }
    }
};
var mediaSchema = {
    oneOf: [deprecatedImageSchema, photoSchema] // @NOTE: Captions, Labels, and Logos are not yet enabled
};
module.exports = mediaSchema;
